function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1,.cls-2{opacity:0.5;}.cls-2,.cls-3{fill:#244393;}.cls-4{fill:#1e2b79;}.cls-5{fill:#141f4c;}.cls-6{fill:#fff;}.cls-7{fill:#4252b7;opacity:0.15;}.cls-8{fill:#fbc2c8;}.cls-9{fill:#cc9fa6;}.cls-10{fill:#fec430;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, React.createElement("g", {
  id: "Ebene_1-2",
  "data-name": "Ebene 1"
}, React.createElement("g", {
  id: "Schatten",
  className: "cls-1"
}, React.createElement("polygon", {
  className: "cls-2",
  points: "459.1 349.95 343.87 315.65 303.87 283.65 356.87 273.65 403.87 269.65 459.1 349.95"
}), React.createElement("polygon", {
  className: "cls-2",
  points: "134.51 186.67 162.87 210.65 173.87 207.65 167.87 196.65 143.87 179.65 134.51 186.67"
}), React.createElement("polygon", {
  className: "cls-3",
  points: "167.87 294.65 194.87 272.65 220.87 289.65 409.87 409.65 307.87 319.65 235.87 283.65 201.87 252.65 185.87 259.65 165.87 274.65 167.87 294.65"
})), React.createElement("path", {
  id: "Hose",
  className: "cls-4",
  d: "M248.87,301.65c.12,2,180.5,121.5,180.5,121.5,3,2,5,1,10-4,1.38-1.37,1.61-4.18,0-7-4-7-36.85-47.7-69-83-5.35-5.88-40.5-33.5-40.5-33.5s57.88-18,62-18c3,0,65,71,65,71s3,4,9.5-1.5c5.12-4.33,4-5,2-10s-35.5-76.84-50-101c-1.5-2.5,3.5-3.5-76.5,9.5-17.45,2.84-32-4.29-33-4s-21.78,9.21-35,23C250.87,288.65,248.73,299.19,248.87,301.65Z"
}), React.createElement("polygon", {
  id: "Hosenschatten",
  className: "cls-5",
  points: "329.87 295.65 309.87 283.65 363.33 285.46 329.87 295.65"
}), React.createElement("g", {
  id: "Schuhe"
}, React.createElement("path", {
  className: "cls-4",
  d: "M439.68,417.8s9.33-3.5,15.17,2.34,7,11.67,0,14-20.54-3.71-20.78-10.61S439.68,417.8,439.68,417.8Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M467.68,344.8s9.33-3.5,15.17,2.34,7,11.67,0,14-20.54-3.71-20.78-10.61S467.68,344.8,467.68,344.8Z"
})), React.createElement("path", {
  id: "Oberk\\xF6rper_Hintergrund",
  "data-name": "Oberk\\xF6rper Hintergrund",
  className: "cls-6",
  d: "M249.87,302.65s-44.55-27.57-52-38c-5-7-20.7,23.06-33,32-11,8-61,27-66,26-3.1-.62-7-1-7-7s51-38,53-42,15-57,20-69c1.22-2.91,26.45-3.45,29-6,2-2-3-19-2-21,1.85-3.68,42.14-32.27,45-38,2-4,8.78-66.38,12-68,4-2,4-2,9,0,7.25,2.9,15.92,67.47,12,74-3,5-14,27-24,39a837,837,0,0,1,63,57c1,1-16.68,9.49-30,20C259.87,276.65,249.87,302.65,249.87,302.65Z"
}), React.createElement("polygon", {
  id: "Seitenschatten",
  className: "cls-7",
  points: "202.87 254.65 309.87 343.55 249.87 302.65 224.87 286.65 195.1 262.44 202.87 254.65"
}), React.createElement("g", {
  id: "H\\xE4nde"
}, React.createElement("path", {
  className: "cls-8",
  d: "M249.83,69.49a11.45,11.45,0,0,0,4.07,1.16c1.74,0,4.39-.41,5-1a18.53,18.53,0,0,0,2.59-6.56c.58-2.91,2.33-9.31-2.33-9.31s-7-1.16-7.56,3.49-1.74,6.4-2.33,5.82-3.49-4.65-4.65-2.33.58,4.08,1.16,5.24S249.83,69.49,249.83,69.49Z"
}), React.createElement("path", {
  className: "cls-8",
  d: "M90.93,314.61a11.49,11.49,0,0,1,1.8,3.83c.28,1.73.29,4.41-.19,5.07a18.46,18.46,0,0,1-6.06,3.61c-2.78,1.05-8.81,3.8-9.56-.8s-2.27-6.7,2.23-8,6-2.75,5.37-3.23-5.16-2.7-3-4.22,4.12-.08,5.36.3S90.93,314.61,90.93,314.61Z"
})), React.createElement("path", {
  id: "Schnalle",
  className: "cls-6",
  d: "M284.57,263.45s-3.76,2.69-4.86,4.39,1.78,2.94,2.76,2.81c1.72-.22,5.4-3.25,5.4-4.38S286.22,262.32,284.57,263.45Z"
}), React.createElement("path", {
  id: "Gesichtsfarbe",
  className: "cls-8",
  d: "M169.87,204.65l-33-26s-3,3-8-1c-4.55-3.64-5-10-3-12s16-10,20-24,30,7,35,15,4,19-3,20l17,8-1,14Z"
}), React.createElement("g", {
  id: "Halskonturen"
}, React.createElement("path", {
  className: "cls-4",
  d: "M178.87,178.65c3.75.13,13,8,13,8v-4s-9.17-5-12.71-6a7.25,7.25,0,0,0-2.29,0C176,176.91,176.34,178.57,178.87,178.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M167.87,203.65s-29-21-28-23,9,6,12,8S172.69,203.55,167.87,203.65Z"
})), React.createElement("g", {
  id: "Oberk\\xF6rper_Konturen",
  "data-name": "Oberk\\xF6rper Konturen"
}, React.createElement("path", {
  className: "cls-4",
  d: "M194.87,263.65c14,15,39,31,40,29,.9-1.78-16-12-22-17-4.48-3.73-13.37-11.24-16-13C193.87,260.65,194.63,263.4,194.87,263.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M238.87,181.65c5.94,6.36,19.86,14.88,32,25,18,15,36.43,35.16,37,34,.9-1.78-19.48-22.54-29-31a341.27,341.27,0,0,0-38-29C237.87,178.65,238.63,181.4,238.87,181.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M202.87,254.65c-30,36.93-29.68,36.49-34.72,40.16-5.28,3.84-29.86,16.22-35.28,17.84s-19.84,8.38-27,10c-7.45,1.69-13,2-13-2,0-4.49-3-6.54,0-9,11.85-9.65,51-36,52-38s18-66.28,19-69,4-2,2,4c-1.61,4.84-17,66-18,67s-35,25-36,26-13,10-15,12-2,2-1,4,2,4,8,2c18.9-6.3,49.21-18.23,63-29,5.3-4.13,30-34,31-35S202.87,252.65,202.87,254.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M242.87,182.65a2.05,2.05,0,0,0,3,2s18-21,24-37c0,0,4-5,1-28.06-3.24-24.91-7.9-44.84-11-47.94s-6-1-9-2c-2.61-.87-3.69,1.11-5,9,0,0-7.07,47.94-8,54s-2.29,9-5.63,12-38.34,29-40.34,33c-1.24,2.48,4,0,9-5,4.53-4.52,31-24,33-26s6-5,8-21,7-49,8-51,4-2,7-1c5.37,1.79,6,18,10,40,4,21.85,2,26,1,30s-6,15-16,28S242.87,182.65,242.87,182.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M184.87,199.65c-20,1-20,4-20,4s0,2,5,1,27-3,27-5-2-12-2-15-2-5-3-6c-1.41-1.41-.87,3.63,0,8,1,5,1.47,9.76,1,11S184.87,199.65,184.87,199.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M229.22,193.61s-5.07,9.31-9.3,11.85,1.69,2.53,2.53,1.69c4.23-4.23,6.77-7.62,8.46-11C231.76,194.46,230.07,192.77,229.22,193.61Z"
})), React.createElement("g", {
  id: "Gesicht"
}, React.createElement("g", {
  id: "Augen"
}, React.createElement("path", {
  className: "cls-4",
  d: "M144.42,168.92s.14-7.14,4.25-10,.93,1.37-.86,4.62C147,165,145.58,169.13,144.42,168.92Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M153.61,152.22s1.69-5.7,5.61-7.05.45,1.31-1.71,3.52C156.59,149.63,154.49,152.65,153.61,152.22Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M154.7,163.1c.54,1.89,3.19,6.84-5.6,6.1,0,0-1.18,1.56,1.4,2s6.08-1.24,6.68-2.32c1.35-2.43.81-4.31-.6-6.36C155.88,161.54,154,160.57,154.7,163.1Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M165.24,150.63c.39,1.89,2.61,7-6,5.56,0,0-1.28,1.44,1.22,2.11s6.06-.75,6.74-1.77c1.5-2.28,1.11-4.17-.11-6.29C166.52,149.18,164.72,148.09,165.24,150.63Z"
})), React.createElement("path", {
  id: "Nase",
  className: "cls-9",
  d: "M166.89,161.82c-.57-.1-.17,1.52-.9,2.87-.53,1-2.14,1.58-2.8,2.27-1.55,1.61,2.7.71,4.42-.72C168.81,165.22,168.46,162.09,166.89,161.82Z"
}), React.createElement("path", {
  id: "Mund",
  className: "cls-4",
  d: "M175.44,160.62c-1.32.45-3.27,1.64-2.07,6.31s5.66-1.68,5.33-3.2S178,159.77,175.44,160.62Z"
})), React.createElement("path", {
  id: "Haare",
  className: "cls-4",
  d: "M135.87,176.65c-5,3-10-2.5-10-5,0-6,5-2,5-2,.63-1.47,0-6,0-6s1.49,4.41,6,1c4.31-3.25.45-8.63,0-9,0,0,5.13,5.1,9,0s1-6-.88-8c-1.55-1.61,5.58,3.69,7.75.05s2.66-5.82.24-7.28L150.55,139a5,5,0,0,0,5.09-.25c2.67-1.7,6.05-8.74,1-12.61s-11-6.14-14.88-1-2.66,4.82-2.41,5.79a7.28,7.28,0,0,0-4.38-4.09c-3.39-1.2-13.82,2.45-12.35,8.27,0,0-3.65-2.18-7.52,2.92s0,12.37,2,11.88c0,0-5.43-1.45-8.33,3.41s2.19,11.36,2.19,11.36,0,7,3,12c0,0,5,5,11,3,0,0-8,2-3,7s9,2,10,0c0,0,2,6,7.69,3,.89-.47,1.31,4,6.31,4s5-2.59,6-4Z"
}), React.createElement("g", {
  id: "Gras"
}, React.createElement("path", {
  className: "cls-4",
  d: "M535.81,314c-2.78-2.78,2.78-13.91,0-23.19s5.42,4.64,4.49,13,4.5-1.84,3.57-10.19,3-46,4,7c.6,31.59,1.85-3.8,1.85-7.51s2.74-15.65,3.15-4.49c.37,9.94,2.08,7.78,3,17s-.58,3.75,1.27,11.17C558.35,321.67,539.09,317.32,535.81,314Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M314.81,48c-2.78-2.78-2.14-22.78-.94-32.39,1-8,5,9,5.43,22.19.28,8.39,1.64,1.16,2.57-7.19,1-9,1.14-11.91,3,3,1,8,3,0,3.85-24.51.13-3.71,2.74-15.65,3.15-4.49.37,9.94,2.08,22.78,3,32s1,7,1.27,14.17C336.33,55.81,318.09,51.32,314.81,48Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M187.81,341c-2.78-2.78,2.78-13.91,0-23.19s7.42,4.64,6.49,13,2.78-7.42,1.86-15.77,1.85-18.55,3.71,13,1.85-10.21,1.85-13.92,1.86-18.55,2.79-7.42,0,12.11.92,21.34,1.86,8.34,3.71,15.76C210.35,348.67,191.09,344.32,187.81,341Z"
})), React.createElement("g", {
  id: "Symbole"
}, React.createElement("path", {
  className: "cls-10",
  d: "M0,252.62c-.52-2.18,5.69-8.23,7.69-8.31s7.22,5.73,18.14,3.31,8.61-10.34,10.57-11.42c1.24-.68,11.91-2.46,13-.5S47.33,251,35.24,257.27C20.52,264.84,1.22,257.57,0,252.62Z"
}), React.createElement("path", {
  className: "cls-10",
  d: "M329.87,178.13c0,2.64,22.43,14.51,25.07,14.51,6.16,0,39.44-26.17,35.63-29-5.28-4-11.88-4-14.51-4s-19.8,14.52-21.12,14.52-11.87-4-13.19-5.28S329.87,174.4,329.87,178.13Z"
}), React.createElement("path", {
  className: "cls-10",
  d: "M198.21,424c2.61,4.27,7.26,6.12,9.11,6.85s17-3.68,17.93-3.31,7.26,9.11,7.82,10.4,16.91-2.55,18-5.18c.35-.87-8.23-6.58-11.26-10.34,9.31-2.55,19.09-6.34,18-8.12-2.61-4.26-7.26-6.11-9.12-6.84s-18,4.68-18.93,4.31-7.26-6.11-7.82-7.41-9.9.56-11,3.19c-.34.87,2.24,4.58,5.26,8.33C206.91,418.44,197.12,422.23,198.21,424Z"
})), React.createElement("g", {
  id: "Schlafen"
}, React.createElement("path", {
  className: "cls-4",
  d: "M176.87,113.65c0,1,0,2-3,2h-7s-1,0,0-2c0,0,5-6,5-7h-4c-2,0-1-2.21-1-3,0-1,10-2,11,0,.45.9-7,9-6,9S176.87,112.65,176.87,113.65Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M206.69,93.68c.67,1.4,1.34,2.79-2.84,4.81l-9.76,4.69s-1.4.67-1.34-2.79c0,0,2.94-11.72,2.27-13.11L189.44,90c-2.78,1.34-2.87-2.41-3.4-3.51-.67-1.4,12.6-9.5,15.34-7.38,1.22.94-3.73,17.25-2.33,16.57S206,92.29,206.69,93.68Z"
}), React.createElement("path", {
  className: "cls-4",
  d: "M175.5,74.92c-.59,1.89-1.18,3.78-6.86,2L155.39,72.8s-1.89-.59,1.18-3.78c0,0,13-8.41,13.6-10.3l-7.57-2.36c-3.79-1.18-.59-4.78-.12-6.27.59-1.89,20.1,2.12,20.82,6.49.31,2-18.57,12.9-16.67,13.49S176.09,73,175.5,74.92Z"
}))));

var SvgAllDone = function SvgAllDone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 557.2 438.2",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAllDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/all-done.55fb3770.svg";
export { ForwardRef as ReactComponent };